import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import _ from 'lodash';
import { wireSet } from 'ui/hoc/prop-wire'; // import Checkbox from 'ui/components/checkbox'

import Checkbox from './checkbox';

var log = require('loglevel').getLogger('table');

var DataRow = createReactClass({
  displayName: "DataRow",
  propTypes: {
    id: PropTypes.string,
    className: PropTypes.string,
    fields: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    force: PropTypes.bool,
    onInputChange: PropTypes.func,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onContextMenu: PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      force: false
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    if (nextProps.force) {
      log.debug('DataRow::shouldComponentUpdate::forced');
      return true;
    }

    if (nextProps.className !== this.props.className) {
      log.debug('DataRow::shouldComponentUpdate::className changed');
      return true;
    }

    if (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
      log.debug('DataRow::shouldComponentUpdate::data changed');
      return true;
    }

    return false;
  },
  renderField: function renderField(name, value, fieldCfg, data) {
    var _this$props = this.props,
        id = _this$props.id,
        onInputChange = _this$props.onInputChange;
    var formatter = fieldCfg.formatter,
        editor = fieldCfg.editor,
        props = fieldCfg.props;

    if (formatter) {
      if (_.isFunction(formatter)) {
        return formatter(value, data, id);
      } else {
        return formatter;
      }
    } else if (editor) {
      if (_.isFunction(props)) {
        props = props(data);
      } // TODO: check editor must be ReactClass


      props = _.assign({
        name: name,
        value: value,
        onChange: onInputChange && onInputChange.bind(null, id, name)
      }, props || {});
      return /*#__PURE__*/React.createElement(editor, props);
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "pre"
      }, value);
    }
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        data = _this$props2.data,
        fields = _this$props2.fields,
        id = _this$props2.id,
        className = _this$props2.className,
        onClick = _this$props2.onClick,
        onDoubleClick = _this$props2.onDoubleClick,
        onContextMenu = _this$props2.onContextMenu;
    return /*#__PURE__*/React.createElement("tr", {
      id: id,
      onClick: onClick,
      onDoubleClick: onDoubleClick,
      onContextMenu: onContextMenu,
      className: className
    }, _.map(fields, function (field, key) {
      var val = _.get(data, field.keyPath || key, null); // to support traverse of nested field properties, eg a.b.c


      return field.hide ? null : /*#__PURE__*/React.createElement("td", {
        key: key,
        className: key
      }, _this.renderField(key, val, field, data));
    }));
  }
});
var SubDataRow = createReactClass({
  displayName: "SubDataRow",
  propTypes: {
    id: PropTypes.string,
    className: PropTypes.string,
    fields: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    force: PropTypes.bool,
    onInputChange: PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      force: false
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    if (nextProps.force) {
      log.debug('SubDataRow::shouldComponentUpdate::forced');
      return true;
    }

    if (nextProps.className !== this.props.className) {
      log.debug('SubDataRow::shouldComponentUpdate::className changed');
      return true;
    }

    if (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
      log.debug('SubDataRow::shouldComponentUpdate::data changed');
      return true;
    }

    return false;
  },
  renderField: function renderField(name, value, fieldCfg, data) {
    var _this$props3 = this.props,
        id = _this$props3.id,
        onInputChange = _this$props3.onInputChange;
    var formatter = fieldCfg.formatter,
        editor = fieldCfg.editor,
        props = fieldCfg.props;

    if (formatter) {
      if (_.isFunction(formatter)) {
        return formatter(value, data, id);
      } else {
        return formatter;
      }
    } else if (editor) {
      if (_.isFunction(props)) {
        props = props(data);
      } // TODO: check editor must be ReactClass


      props = _.assign({
        name: name,
        value: value,
        onChange: onInputChange && onInputChange.bind(null, id, name)
      }, props || {});
      return /*#__PURE__*/React.createElement(editor, props);
    } else {
      return value;
    }
  },
  render: function render() {
    var _this$props4 = this.props,
        data = _this$props4.data,
        fields = _this$props4.fields,
        id = _this$props4.id,
        className = _this$props4.className;
    return /*#__PURE__*/React.createElement("tr", {
      id: id + '_sub',
      className: className
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: _.size(fields)
    }, data.table));
  }
});
/**
 * A React DataTable Component. Renders **data** according to **fields** configuration
 * @constructor
 * @param {string} [id] - Table element #id
 * @param {renderable} [caption] - Table caption
 * @param {renderable} [footer] - Table footer
 * @param {string} [className] - Classname for the container
 * * bland - Do not color alternate rows
 * * nohover - Do not change color when hovering over rows
 * * fixed-header - Fix table header when height is limited, allow table body to scroll
 * * column - Make table a column table. Ie data rows will be from left to right, instead of top to bottom
 * * border-inner-vertical - Show vertical border inside table
 * * border-inner-horizontal - Show horizontal border inside table
 * * border-inner - Show both vertical and horizontal border inside table
 * * border-outer - Show table border outline
 * * border-all - Show all border, outer + inner
 * @param {object} fields - All fields definition, in key-config pair, each key represents a column
 * @param {object} fields.key - Config for this **key** field
 * @param {renderable} [fields.key.label=key] - label for this field
 * @param {string | array.<string>} [fields.key.keyPath=key] - key path for this field
 * @param {renderable} [fields.key.sortable=false] - is column sortable?
 * @param {string | array.<string>} [fields.key.sortKeyPath=keyPath] - key path used for sorting
 * @param {renderable} [fields.key.hide=false] - hide this column?
 * @param {string} [fields.key.className] - classname of this column
 * @param {function | renderable} [fields.key.formatter] - what to render in this field? If function, first argument will be data value corresponding to the field, second argument is data for the entire row
 * @param {function | component} [fields.key.editor] - If this field is an input, the react component class to use
 * @param {object} [fields.key.props] - If this field is an input, props for the above react class, see individual doc for the base class
 * @param {array} [data] - Data to fill table with
 * @param {object} [rows] - Limit data to show
 * @param {number} [rows.start=0] - row to start with
 * @param {number} [rows.end=data.length] - row to end with (not including end)
 * @param {string} [rowIdField] - The field key which will be used as row dom #id
 * @param {string | function} [rowClassName] - Classname of a data row
 * @param {boolean | object} [selectable=false] - Is table rows selectable? If yes checkboxes will appear
 * @param {boolean} [selectable.toggleAll=false] - Show toggle all checkbox in header?
 * @param {array.<string>} [defaultSelected] - Selected row ids
 * @param {array.<string>} [selected] - Default selected row ids
 * @param {object} [selectedLink] - Link to update selections. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} selectedLink.value - value to update
 * @param {function} selectedLink.requestChange - function to request value change
 * @param {function} [onSelectionChange] - Callback function when row is selected. <br> Required when selected prop is supplied
 * @param {array} onSelectionChange.value - current selected row ids
 * @param {object} onSelectionChange.eventInfo - event related info
 * @param {array} onSelectionChange.eventInfo.before - previous selected row ids
 * @param {string} onSelectionChange.eventInfo.id - id triggering change
 * @param {boolean} onSelectionChange.eventInfo.selected - selected?
 * @param {object} [defaultSort] - Default sort config
 * @param {string} [defaultSort.field] - Default sort field
 * @param {boolean} [defaultSort.desc=false] - Is sort order descending by default?
 * @param {object} [sort] - Current sort config
 * @param {string} [sort.field] - Current sort field
 * @param {boolean} [sort.desc=false] - Is sort order descending?
 * @param {object} [sortLink] - Link to update sort. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} sortLink.value - sort to update
 * @param {function} sortLink.requestChange - function to request sort change
 * @param {function} [onSort] - Callback function when sort is changed. <br> Required when sort prop is supplied
 * @param {object} onSort.value - current sort object
 * @param {object} onSort.eventInfo - event related info
 * @param {object} onSort.eventInfo.before - previous sort object
 * @param {function} [onRowClick] [description]
 * @param {function} [onRowDoubleClick] [description]
 * @param {function} [onRowContextMenu] [description]
 * @param {function} [onScroll] [description]
 * @param {function} [containerOnScroll] [description]
 * @param {function} [onInputChange] - Input change event
 * @param {string} onInputChange.rid - row id of this input
 * @param {string} onInputChange.name - input name
 * @param {string|number} onInputChange.value - input value
 * @param {renderable} [info] - React renderable object, display additional information about the list
 * @param {string} [infoClassName] - Assign className to info node
 * @param {string} [subClassName] - Classname for the subtable container
 * @param {object} subRow - subtable object
 * @param {boolean} enableTextWordWrap - Enable auto word wrap. Need to set th width.
 * @param {boolean} enableIgnoreSelection - Enable ignore selection items.
 * @param {object} ignoreSelectionObj - Selection Ignore items. ex: {type: 'name', value: [admin]}
 *
 * @example
// controlled

import $ from 'jquery'
import cx from 'classnames'
import DataTable from 'core/components/table'

React.createClass({
    getInitialState() {
        return {
            selected:[],
            info: null,
            error: false,
            data: []
        }
    },
    handleSelect(selected) {
        this.setState({selected})
    },
    componentDidMount() {
        this.loadList()
    },
    loadList() {
        this.setState({data:[], info: 'Loading...', error:false}, () => {
            $.get('http://www.omdbapi.com', {
                    s:'abc'
                })
                .done(({Error:error, Search:list=[], totalResults:total=0}) => {

                    if (error) {
                        this.setState({info:error, error:true, pages:null});
                        return;
                    }

                    if (total === 0) {
                        this.setState({info:'No movies found!', pages:null});
                        return;
                    }

                    this.setState({info:null, data:list});
                })
                .fail(xhr => {
                    this.setState({info:xhr.responseText, error:true});
                })
        });
    },
    render() {
        let {data, selected, info, error} = this.state;

        return <div className='c-box seamless'>
            <div className='content'>
                <DataTable data={data}
                    fields={{
                        imdbID: { label:'ID', sortable:true },
                        Title: { label:'Title', sortable:true },
                        Year: { label:'Year', sortable:true }
                    }}
                    className='fixed-header'
                    rowIdField='imdbID'
                    info={info}
                    infoClassName={cx({'c-error':error})}
                    defaultSort={{
                        field:'Title',
                        desc: false
                    }}
                    selectable={true}
                    selected={selected}
                    onSelectionChange={this.handleSelect}/>
            </div>
        </div>
    }
});
 */

var DataTable = createReactClass({
  displayName: "DataTable",
  propTypes: {
    id: PropTypes.string,
    caption: PropTypes.node,
    footer: PropTypes.node,
    className: PropTypes.string,
    rowIdField: PropTypes.string,
    rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    fields: PropTypes.objectOf(PropTypes.shape({
      label: PropTypes.node,
      keyPath: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      sortable: PropTypes.bool,
      sortKeyPath: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      hide: PropTypes.bool,
      className: PropTypes.string,
      formatter: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
      editor: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]),
      props: PropTypes.object
    })).isRequired,
    data: PropTypes.array,
    rows: PropTypes.shape({
      start: PropTypes.number,
      end: PropTypes.number
    }),
    forceRefresh: PropTypes.bool,
    selectable: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      toggleAll: PropTypes.bool
    })]),
    selected: PropTypes.arrayOf(PropTypes.string),
    onSelectionChange: PropTypes.func,
    sort: PropTypes.shape({
      field: PropTypes.string,
      desc: PropTypes.bool
    }),
    onSort: PropTypes.func,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
    onRowContextMenu: PropTypes.func,
    onScroll: PropTypes.func,
    containerOnScroll: PropTypes.func,
    onInputChange: PropTypes.func,
    info: PropTypes.node,
    infoClassName: PropTypes.string,
    enableTextWordWrap: PropTypes.bool,
    enableIgnoreSelection: PropTypes.bool,
    ignoreSelectionObj: PropTypes.object
  },
  getDefaultProps: function getDefaultProps() {
    return {
      data: [],
      selectable: false,
      forceRefresh: true,
      enableIgnoreSelection: false
    };
  },
  getRowId: function getRowId(rowData, rowIdField) {
    if (!rowIdField) {
      log.error('getRowId:: rowIdField prop must be specified');
      return null;
    }

    var fields = this.props.fields;
    var fieldCfg = this.formatField(rowIdField, fields[rowIdField]);

    var id = _.get(rowData, _.get(fieldCfg, 'keyPath', rowIdField));

    if (!id) {
      log.error("getRowId:: unable to produce id based on config ".concat(fieldCfg));
      return null;
    }

    return id + '';
  },
  formatField: function formatField(key, fieldCfg) {
    if (_.isString(fieldCfg)) {
      return {
        label: fieldCfg
      };
    } else {
      return _objectSpread({
        label: key
      }, fieldCfg);
    }
  },
  formatFields: function formatFields() {
    var _this2 = this;

    var _this$props5 = this.props,
        fields = _this$props5.fields,
        selectable = _this$props5.selectable,
        _this$props5$selected = _this$props5.selected,
        selected = _this$props5$selected === void 0 ? [] : _this$props5$selected,
        data = _this$props5.data,
        enableIgnoreSelection = _this$props5.enableIgnoreSelection;
    fields = _.mapValues(fields, function (fieldCfg, key) {
      return _this2.formatField(key, fieldCfg);
    });

    if (selectable) {
      var total = data.length;
      var numSelected = selected.length;
      fields = _objectSpread({
        selector: {
          label: selectable.toggleAll ? /*#__PURE__*/React.createElement(Checkbox, {
            checked: numSelected > 0,
            className: cx({
              partial: numSelected > 0 && numSelected < total
            }),
            onChange: this.handleToggleAll
          }) : '',
          formatter: function formatter(v, row, rid) {
            if (enableIgnoreSelection && _this2.calIgnoreItem(row)) return null; // if(row.username === 'admin' || row.name === 'Administrator Group')
            //     return null

            return /*#__PURE__*/React.createElement(Checkbox, {
              checked: selected.indexOf(rid) >= 0,
              onChange: _this2.handleRowSelect.bind(_this2, rid)
            });
          }
        }
      }, fields);
    }

    return fields;
  },
  handleSort: function handleSort(evt) {
    var _this$props6 = this.props,
        onSort = _this$props6.onSort,
        _this$props6$sort = _this$props6.sort,
        sortField = _this$props6$sort.field,
        sortDesc = _this$props6$sort.desc;
    var newSortField = evt.currentTarget.id;
    var sortObj = {
      field: newSortField,
      desc: newSortField === sortField ? !sortDesc : false
    };
    onSort(sortObj);
  },
  handleToggleAll: function handleToggleAll(selected) {
    var _this3 = this;

    var _this$props7 = this.props,
        onSelectionChange = _this$props7.onSelectionChange,
        data = _this$props7.data,
        rowIdField = _this$props7.rowIdField,
        ignoreSelectionObj = _this$props7.ignoreSelectionObj,
        enableIgnoreSelection = _this$props7.enableIgnoreSelection; // filter username admin

    var newData = [];

    if (enableIgnoreSelection) {
      _.forEach(data, function (o) {
        if (!_.some(ignoreSelectionObj.value, function (value) {
          return value === o[ignoreSelectionObj.type];
        })) newData.push(o);
      });
    } else {
      newData = data;
    }

    var newSelected = selected ? _.map(newData, function (row) {
      return _this3.getRowId(row, rowIdField);
    }) : [];
    onSelectionChange(newSelected, {
      id: null,
      selected: selected
    });
  },
  handleRowSelect: function handleRowSelect(rid, selected) {
    var _this$props8 = this.props,
        onSelectionChange = _this$props8.onSelectionChange,
        curSelected = _this$props8.selected;
    var newSelected = selected ? [].concat(_toConsumableArray(curSelected), [rid]) : _.without(curSelected, rid);
    onSelectionChange(newSelected, {
      id: rid,
      selected: selected
    });
  },
  handleRowClick: function handleRowClick(row, evt) {
    var rid = evt.currentTarget.id;
    this.props.onRowClick && this.props.onRowClick(rid, row, evt);
  },
  handleRowDoubleClick: function handleRowDoubleClick(row, evt) {
    var rid = evt.currentTarget.id;
    this.props.onRowDoubleClick && this.props.onRowDoubleClick(rid, row, evt);
  },
  handleContextMenu: function handleContextMenu(row, evt) {
    var rid = evt.currentTarget.id;
    this.props.onRowContextMenu && this.props.onRowContextMenu(rid, row, evt);
  },
  calIgnoreItem: function calIgnoreItem(rowData) {
    var ignoreSelectionObj = this.props.ignoreSelectionObj;
    var result = [];
    var type = ignoreSelectionObj.type;

    _.forEach(ignoreSelectionObj.value, function (value) {
      if (rowData[type] && rowData[type] === value) result.push(rowData[type]);
    });

    return result.length > 0 ? true : false;
  },
  render: function render() {
    var _this4 = this;

    var _this$props9 = this.props,
        id = _this$props9.id,
        className = _this$props9.className,
        caption = _this$props9.caption,
        footer = _this$props9.footer,
        info = _this$props9.info,
        infoClassName = _this$props9.infoClassName,
        data = _this$props9.data,
        rows = _this$props9.rows,
        rowIdField = _this$props9.rowIdField,
        subRow = _this$props9.subRow,
        selectable = _this$props9.selectable,
        selected = _this$props9.selected,
        _this$props9$sort = _this$props9.sort,
        sortField = _this$props9$sort.field,
        sortDesc = _this$props9$sort.desc,
        rowClassName = _this$props9.rowClassName,
        subClassName = _this$props9.subClassName,
        forceRefresh = _this$props9.forceRefresh,
        onRowClick = _this$props9.onRowClick,
        onRowDoubleClick = _this$props9.onRowDoubleClick,
        onRowContextMenu = _this$props9.onRowContextMenu,
        onInputChange = _this$props9.onInputChange,
        onScroll = _this$props9.onScroll,
        enableTextWordWrap = _this$props9.enableTextWordWrap,
        containerOnScroll = _this$props9.containerOnScroll;
    var refreshAll = forceRefresh === true;
    var fields = this.formatFields();

    if (!refreshAll && !_.isArray(forceRefresh)) {
      forceRefresh = [forceRefresh];
    }
    /*
    if (sortField && fields[sortField] && fields[sortField].sortable) {
        data = _.orderBy(
            data,
            [
                item => {
                    const val = _.get(item, fields[sortField].sortKeyPath||fields[sortField].keyPath||sortField)
                    return _.isString(val) ? val.toLowerCase() : val
                },
                rowIdField
            ],
            [sortDesc?'desc':'asc'])
    }
    */


    if (rows) {
      var start = rows.start,
          end = rows.end;
      data = data.slice(start, end);
    }

    var newData = _.clone(data);

    if (subRow) {
      var index = _.findIndex(data, ['id', subRow.parentId]);

      if (index != -1) {
        var subRowId = rowIdField ? this.getRowId(data[index], rowIdField) + '_subRowId' : index + '_subRowId';
        newData = [].concat(_toConsumableArray(data.slice(0, index + 1)), [_.set(subRow, 'id', subRowId)], _toConsumableArray(data.slice(index + 1)));
      }
    }

    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
      className: "container",
      onScroll: containerOnScroll
    }, /*#__PURE__*/React.createElement("table", {
      id: id,
      className: cx('c-table', {
        selectable: selectable
      }, className)
    }, caption ? /*#__PURE__*/React.createElement("caption", null, caption) : null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
      id: "header"
    }, _.map(fields, function (_ref, key) {
      var _ref$sortable = _ref.sortable,
          sortable = _ref$sortable === void 0 ? false : _ref$sortable,
          _ref$hide = _ref.hide,
          hide = _ref$hide === void 0 ? false : _ref$hide,
          label = _ref.label,
          fieldClassName = _ref.className;

      if (hide) {
        return null;
      }

      return /*#__PURE__*/React.createElement("th", {
        id: key,
        key: key,
        className: cx(key, {
          sortable: sortable
        }, fieldClassName),
        onClick: function onClick(evt) {
          if (sortable) _this4.handleSort(evt);
        }
      }, /*#__PURE__*/React.createElement("div", null, enableTextWordWrap ? /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, label) : label, sortable ? key === sortField ? /*#__PURE__*/React.createElement("span", {
        className: 'dir selected ' + (sortDesc ? 'desc' : '')
      }, sortDesc ? "\u25BC" : "\u25B2") : /*#__PURE__*/React.createElement("span", {
        className: "dir"
      }, "\u25B2") : ''));
    }))), /*#__PURE__*/React.createElement("tbody", {
      onScroll: onScroll
    }, info ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      className: cx('c-info', infoClassName),
      colSpan: _.size(fields)
    }, info)) : _.map(newData, function (row, index) {
      var rid = (rowIdField ? _this4.getRowId(row, rowIdField) : index) + '';
      var _className = rowClassName;

      if (rowClassName) {
        if (_.isFunction(rowClassName)) {
          _className = rowClassName(row);
        }
      }

      if (selected.indexOf('' + rid) >= 0) {
        _className = [_className, 'selected'];
      }

      if (!row.data) {
        return /*#__PURE__*/React.createElement(DataRow, {
          key: rid,
          id: rid,
          fields: fields,
          data: row,
          className: cx(_className),
          force: refreshAll || forceRefresh.indexOf('' + rid) >= 0,
          onInputChange: onInputChange,
          onContextMenu: onRowContextMenu ? _this4.handleContextMenu.bind(_this4, row) : null,
          onClick: onRowClick ? _this4.handleRowClick.bind(_this4, row) : null,
          onDoubleClick: onRowDoubleClick ? _this4.handleRowDoubleClick.bind(_this4, row) : null
        });
      } else {
        return /*#__PURE__*/React.createElement(SubDataRow, {
          key: rid,
          id: rid,
          fields: fields,
          data: row,
          className: subClassName,
          force: refreshAll || forceRefresh.indexOf('' + rid) >= 0,
          onInputChange: onInputChange
        });
      }
    })), footer ? /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, footer))) : null)));
  }
});
export default wireSet(DataTable, {
  sort: {
    changeHandlerName: 'onSort',
    defaultValue: {}
  },
  selected: {
    changeHandlerName: 'onSelectionChange',
    defaultValue: []
  }
});